"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const SvgEditPencilSquare = (props, ref) => (React.createElement("svg", { ...props, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 795 794", fill: "currentColor", className: `Icon ${props?.className || ""}`, ref: ref },
    React.createElement("path", { fillRule: "evenodd", d: "M22.103 68.166C36.2 54.04 53.876 46.4 73.905 46.4h394.619l27.479 27.532-74.99 71.668H99.506v548.8H599.23V403.8l99.107-94.646V720c0 20.031-7.133 37.986-21.329 52.21-14.198 14.226-32.141 21.39-52.178 21.39H73.906c-19.809 0-37.41-7.345-51.56-21.15C7.82 758.279.4 740.251.4 720V120c0-20.023 7.605-37.708 21.703-51.834", clipRule: "evenodd" }),
    React.createElement("path", { d: "M755.856 30.75q18.714 18 28.07 36.75t10.106 39q0 19.5-8.983 39-8.982 19.5-27.696 39-8.233 9-59.134 59.25a66991 66991 0 0 1-109.287 107.625Q530.546 408.75 481.517 457.5t-54.269 54q-2.246 1.5-4.117 3a13.3 13.3 0 0 1-4.117 2.25Q410.032 519 382.336 528a5633 5633 0 0 1-57.638 18.375q-29.941 9.375-53.146 17.25t-23.953 7.875q-1.497 0-2.994.375t-2.995.375q-3.743 0-7.485-1.5t-6.737-4.5q-3.743-3.75-5.24-9.375t0-10.875q0-.75 7.112-23.625a7968 7968 0 0 0 16.093-52.5 4614 4614 0 0 0 17.216-58.125q8.235-28.5 11.977-40.5.749-2.25 1.871-4.5 1.124-2.25 3.369-4.5l49.778-49.875q49.777-49.875 110.409-110.25t112.281-112.5 56.14-55.875q5.988-6 26.573-19.875T684.745 0q19.462 0 37.427 7.875t33.684 22.875" })));
const ForwardRef = (0, react_1.forwardRef)(SvgEditPencilSquare);
exports.default = ForwardRef;
